var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-result',{attrs:{"image":_vm.image,"title":_vm.title,"showHotline":false}},[_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.toNextPage()}}},[_vm._v("去支付")])])}
var staticRenderFns = []

export { render, staticRenderFns }